var axios = require('axios')
const apiUrl = process.env.API_URL || '/api/'

export default {
  // Start
  getIdeas (ideasData, cb, errorCb) {
    axios.get(apiUrl + 'ideas', ideasData)
    .then(function (response) {
      cb(response.data)
    })
    .catch(function (error) {
      errorCb(error.message)
    })
  },

  storeIdea (ideaData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'ideas', ideaData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  updateIdea (ideaData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'ideas/' + ideaData._id, ideaData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  deleteIdea (ideaId, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'ideas/' + ideaId + '/delete')
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  // LISTS

  storeList (listData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists', listData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  claimList (data, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists/' + data.list._id + '/claim', data)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  storeIdeaOnList (data, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists/' + data.list._id + '/ideas', data)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  updateIdeaOnList (listId, ideaId, data, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists/' + listId + '/ideas/' + ideaId, data)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  deleteIdeaOnList (data, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists/' + data.list._id + '/ideas/' + data.ideaId + '/delete', data)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  updateList (listData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.post(apiUrl + 'lists/' + listData._id, listData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  getList (listData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrl + 'lists/' + listData.slug, listData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },

  getLists (listData, cb, errorCb) {
    return new Promise((resolve, reject) => {
      axios.get(apiUrl + 'lists', listData)
      .then(function (response) {
        cb(response.data)
        resolve()
      })
      .catch(function (error) {
        errorCb(error.message)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api.js